'use client';
import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import { CartBadge } from '@eliadmin/core/src/components/header/cart-badge';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { formatPrice } from '@eliadmin/core/src/utils/price-utils';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';
import Link from '@eliadmin/core/src/components/link';
import { useMemo } from 'react';
import { LuShoppingCart } from 'react-icons/lu';

export type HeaderCartButtonProps = {
  className?: {
    root?: string;
    info?: string;
    title?: string;
    price?: string;
    badge?: string;
  };
};

export function HeaderCartButton({ className }: HeaderCartButtonProps) {
  const systemLabels = useSystemLabels();
  const me = useCustomerStore(state => state.me);

  const { data: cart } = useQuery({ ...useCartQueryOpts(), enabled: !!me?.authToken });

  return (
    <Link aria-label={systemLabels('cart')} href={ROUTES.CART() ?? '#'} prefetch={false}>
      <Button
        asChild
        variant="outline"
        className={cn(
          'w-fit text-center',
          'relative flex max-h-12 min-h-12 min-w-12 max-w-12 items-center rounded-none border-none bg-white/10 px-0 hover:bg-white/15',
          'ea-cart-button',
          className?.root,
        )}
      >
        <div data-ea-visual-tag="button">
          <div className="relative flex h-5 w-5 items-center text-white">
            {<LuShoppingCart size={20} />}

            <CartBadge
              className={cn(
                'h-5 w-5 bg-primary font-normal text-white hover:bg-primary',
                className?.badge,
              )}
              variant={HEADER_CONFIG.headerMain.cart.badgeVariant}
            />
          </div>
        </div>
      </Button>
    </Link>
  );
}
